export const Skeleton = () => {
  return (
    <div className="p-8 w-full">
      <div className="flex flex-col gap-2 xl:flex-row xl:justify-between">
        <div>
          <div className="animate-pulse rounded-md bg-skeleton w-[80px] h-[30px] truncate" />
          <div className="mt-2 animate-pulse rounded-md bg-skeleton w-[400px] h-[40px] xl:h-[30px] truncate" />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="animate-pulse rounded-md bg-skeleton h-10 w-64" />
          <div className="animate-pulse rounded-md bg-skeleton h-10 w-20" />
          <div className="animate-pulse rounded-md bg-skeleton h-10 w-20" />
        </div>
      </div>
      <div className="animate-pulse rounded-md bg-skeleton h-[600px] w-full mt-9" />
    </div>
  )
}
